import { ThemeUICSSObject } from '@apia/theme';
import { form } from './form';
/* IMPORT HERE */

export const chat: ThemeUICSSObject = {
  form,
  /* PREPEND HERE */
};
